import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { updateMe } from '../../common/users/actions'
import { notificationTypes, roles } from '../../common/config'
import Button from '../components/Button'
import Popup from '../components/Popup'
import StarsReview from '../components/StarsReview'
import GuideList from '../components/GuideList'

const Guide = ({ viewer, tests, notifications, updateMe, intl }) => {
  const newResultsNotification = notifications
    .find(n => n.type === notificationTypes.NEW_TEST_RESULTS)

  tests = tests && tests.toJS()
  if (!viewer || !tests) return null

  return (
    <div>
      {
        viewer.role === roles.TEACHER &&
        <React.Fragment>
          {
            (!tests.length && viewer.seenGuides.guideStep === 1) &&
            <Popup
              title={intl.formatMessage(messages.welcome)}
              onClick={() => updateMe({ seenGuides: { guideStep: 2 } })}
            >
              <StarsReview number={viewer.seenGuides.guideStep} />
              <GuideList step={viewer.seenGuides.guideStep} />
            </Popup>
          }
          {
            (!!tests.length && viewer.seenGuides.guideStep === 2) &&
            <Popup
              title={intl.formatMessage(messages.firstTest)}
              onClick={() => updateMe({ seenGuides: { guideStep: 3 } })}
            >
              <StarsReview number={viewer.seenGuides.guideStep} />
              <GuideList step={viewer.seenGuides.guideStep} />
            </Popup>
          }
          {
            (!!tests.length && viewer.seenGuides.guideStep === 3) &&
            <Popup
              title={intl.formatMessage(messages.testFill)}
              onClick={() => updateMe({ seenGuides: { guideStep: 4 } })}
            >
              <img
                style={{ width: '30rem' }}
                src="/assets/images/computer-room.png"
                alt="Computer room"
              />
              <p>
                {intl.formatMessage(messages.testUrlFill)}: <b><u>vobo.io/test/{tests[0].testId}</u></b>.
                &nbsp;{intl.formatMessage(messages.testCheck)}
              </p>
            </Popup>
          }
          {
            (!!tests.length && newResultsNotification && viewer.seenGuides.guideStep === 4) &&
            <Popup
              title={intl.formatMessage(messages.newResults)}
              onClick={() => updateMe({ seenGuides: { guideStep: 5 } })}
            >
              <StarsReview number={3} />
              <GuideList step={3} />
              {/* Nahradit textom notifikacie */}
              <p>
                {intl.formatMessage(messages.testNewResults, { test: tests[0].name })}
              </p>
              <Link
                to={`/app/results/${tests[0].id}`}
                onClick={() => updateMe({ seenGuides: { guideStep: 5 } })}
              >
                <Button positive>
                  {intl.formatMessage(messages.showResults)}
                </Button>
              </Link>
            </Popup>
          }
        </React.Fragment>
      }
    </div>
  )
}

Guide.defaultProps = {
  notifications: [],
  tests: null,
  viewer: null,
}

Guide.propTypes = {
  intl: PropTypes.object.isRequired,
  tests: PropTypes.object,
  notifications: PropTypes.array,
  updateMe: PropTypes.func.isRequired,
  viewer: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    tests: state.tests.all,
    notifications: state.notifications.all,
    loadedTests: state.tests.loadedTests,
  }), { updateMe }),
  injectIntl,
)

export default enhance(Guide)

const messages = defineMessages({
  welcome: {
    id: 'guide.welcome',
    defaultMessage: 'Vitajte!',
  },
  firstTest: {
    id: 'guide.firstTest',
    defaultMessage: 'Gratulujeme! Máte vytvorený prvý test.',
  },
  testFill: {
    id: 'guide.testFill',
    defaultMessage: 'Nechajte test vyplniť žiakmi.',
  },
  newResults: {
    id: 'guide.newResults',
    defaultMessage: 'Nové výsledky žiakov.',
  },
  testNewResults: {
    id: 'guide.testNewResults',
    defaultMessage: 'Test {test} má nové vyplnené výsledky.',
  },
  showResults: {
    id: 'guide.showResults',
    defaultMessage: 'Zobraziť výsledky.',
  },
  testUrlFill: {
    id: 'guide.testUrlFill',
    defaultMessage: 'Test môžu žiaci vyplniť na adrese',
  },
  testCheck: {
    id: 'guide.testCheck',
    defaultMessage: 'Po vyplnení testu budú automaticky skontrolované odpovede a výsledky uvidíte pri teste.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/Guide.js